import { render, staticRenderFns } from "./right_sidebar.vue?vue&type=template&id=082db0dd"
import script from "./right_sidebar.vue?vue&type=script&lang=js"
export * from "./right_sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports